import styled from 'styled-components'

import { Spinner } from 'components/Spinner'

export const LoadingScreen = styled.div.attrs({ children: <Spinner /> })`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`
